import { call, put, select, takeEvery } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import {
  PHOTO_TYPE_FACE, PHOTO_TYPE_TONGUE, setGuidanceVisibility,
  setPhotoAnalysisResult, setPhotoUploaded,
  setPreviewPhotoAction,
  TAKE_PHOTO_SAGA, UPLOAD_PHOTO_SAGA,
} from '../actions/photo';
import wx from 'weixin-js-sdk';
import { analyzePhoto } from '../api/photo';
import {
  updateFaceResultAction,
  updateTongueResultAction,
} from '../actions/result';
import { safe, } from './util';
import { isWkwebview } from '../util';
import { setWkwebviewPreviewPhotoAction } from '../actions/wkwebview';

const wxPromise = (fn, options) => new Promise((resolve, reject) => {
  try {
    fn.call(wx, {
      ...options,
      complete: r => (r.errMsg.endsWith(':ok') ? resolve(r) : reject(new Error(r.errMsg))),
    });
  } catch (e) {
    reject(e);
  }
});

export function* getPhotoForIPhone({ photoType, src }) {
  let res;
  try {
    res = yield call(wxPromise, wx.getLocalImgData, {
      localId: src,
    });
  } catch (err) {
    if (err.message !== 'chooseImage:cancel') {
      alert(`获取iPhone图像资源错误: ${err.message}`);
    }
    return;
  }
  res = res.localData.replace('jgp', 'jpeg');
  yield put(setWkwebviewPreviewPhotoAction({ src: res, photoType }));
}

export function* takePhoto({ photoType, next }) {
  let res;
  try {
    res = yield call(wxPromise, wx.chooseImage, {
      count: 1,
      sizeType: ['original', 'compressed'],
      sourceType: ['camera', 'album'],
    });
  } catch (err) {
    if (err.message !== 'chooseImage:cancel') {
      alert(`拍照错误: ${err.message}`);
    }
    return;
  }
  yield put(setPhotoUploaded({ photoType, uploaded: false }));
  yield put(setGuidanceVisibility({ photoType }));

  yield put(setPreviewPhotoAction({ src: res.localIds[0], photoType }));
  if (isWkwebview()) {
    yield call(getPhotoForIPhone, { photoType, src: res.localIds[0] });
  }
  if (next) yield put(push(next));
}

export function* watchTakePhoto() {
  yield takeEvery(TAKE_PHOTO_SAGA, safe(takePhoto));
}

const detected = result => (
  result && result.detectRes
);

function* uploadPhoto({ photoType, next }) {
  const { pic, uploaded, unrecognizable } = yield select(state => ({
    pic: state.photo[photoType],
    uploaded: state.photo[`${photoType}PhotoUploaded`],
    unrecognizable: state.photo[`${photoType}Unrecognizable`]
  }));
  let showError = unrecognizable;
  if (!pic) {
    return;
  }

  if (!uploaded) {
    let res;
    try {
      res = yield call(wxPromise, wx.uploadImage, {
        localId: pic,
        isShowProgressTips: 1, // 默认为1，显示进度提示
      });
    } catch (err) {
      if (err.message !== 'uploadImage:cancel') {
        alert(`上传图片错误: ${err.message}`);
      }
      return;
    }
    yield put(setPhotoUploaded({ photoType, uploaded: true }));

    // fetch wkwebviewPhoto analysis API
    const result = yield call(analyzePhoto, res.serverId, photoType);

    // put API result
    if (!detected(result)) {
      showError = true;
    } else if (photoType === PHOTO_TYPE_FACE) {
      showError = false;
      // alert(translateFaceDiagnosisResult(result));
      yield put(updateFaceResultAction(result));
    } else if (photoType === PHOTO_TYPE_TONGUE) {
      showError = false;
      // alert(translateTongueDiagnosisResult(result));
      yield put(updateTongueResultAction(result));
    }
  }

  yield put(setPhotoAnalysisResult({ photoType, unrecognizable: showError }));
  if (showError) {
    yield put(setGuidanceVisibility({ photoType, on: true }));
  } else if (photoType === PHOTO_TYPE_FACE) {
    yield put(setGuidanceVisibility({ photoType: PHOTO_TYPE_TONGUE, on: true }));
  }

  if (!showError && next) {
    yield put(push(next));
  }
}

export function* watchUploadPhoto() {
  yield takeEvery(UPLOAD_PHOTO_SAGA, safe(uploadPhoto));
}



// WEBPACK FOOTER //
// ./src/sagas/photo.js